import { LogoPropsType } from './logoTypes';

export default function DeliveryHeroLogo({ monochrome = false, className }: LogoPropsType) {
  return (
    <svg
      viewBox="0 0 500.3 80.1"
      fill={monochrome ? 'currentColor' : '#D61F26'}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g>
        <path
          d="M93.4,37.6L93.4,37.6l-11,4.5l-0.3,0.2l-2.7,12.2c-0.2,0.4-0.7,0.5-1.1,0.2l-8-9.4l0,0L25.5,64.4
			c-0.3,0.2-0.6-0.3-0.3-0.5l38.8-29l-4.9-11.2c-0.2-0.5,0.2-1.1,0.8-0.9l11.9,2.9l9.2-8.2c0.4-0.3,0.9-0.1,1,0.4l0.9,12.3l10.6,6.2
			C94,36.8,93.9,37.4,93.4,37.6L93.4,37.6z M88,2.4c-13.8-5.4-28.9-1.3-38.3,9l-36.4,39c-0.5,0.5-0.3,1.2,0.3,1.3l9.7,0.6
			c0.8,0,0.9,0.7,0.5,1.2L0.1,79.1c-0.4,0.4,0.1,1.1,0.7,1l33.8-10.7c0.7-0.3,1.3,0.4,1,1l-4.5,8c-0.2,0.5,0.2,1.1,0.8,1l48.9-10.9
			c11.7-1.8,22.1-9.6,26.7-21.4C114.4,29.3,105.7,9.3,88,2.4L88,2.4z M218.9,61.8h-11.1l8.7-40.8l12.2-4.5L218.9,61.8 M195,38.4
			c-2.7,0-4.2,2.2-4.8,4.8c5.3,0,6.9-1.7,6.9-3C197.1,39.2,196.2,38.4,195,38.4 M189,50.3c-0.1,0.3-0.1,0.8-0.1,1.1
			c0,1.8,1.2,2.4,4.5,2.4c3,0,7.1-0.7,9.6-1.6v8.3c-3.1,1.1-8,1.8-11.9,1.8c-9.2,0-13.6-2.5-13.6-10.8c0-8.2,3.8-20.9,18.4-20.9
			c9.3,0,12.1,4.2,12.1,8.6C207.9,44.9,203,49.8,189,50.3 M239.2,29.1c-3.8,0-6.2-2.4-6.2-5.8c0-4.4,3.1-6.8,6.9-6.8
			c3.9,0,6.2,2.4,6.2,5.7C246,26.7,243,29.1,239.2,29.1 M231.3,31.6h11.5L237,61.3h-11.6l4.1-20.8 M275.8,31.6
			c-4,10-8.3,19.7-13.9,29.7h-14.2c-1.8-9.4-2.6-19.4-2.4-29.7h11.6c-0.2,4.8-0.2,9.7,0.1,14.5c0.1,1.3,0.2,2.4,0.3,3.6h0.1
			c0.5-1.2,1.1-2.4,1.6-3.6c2-4.9,3.8-10.2,5.2-14.5H275.8 M291.3,38.4c-2.7,0-4.2,2.2-4.8,4.8c5.3,0,6.9-1.7,6.9-3
			C293.3,39.2,292.5,38.4,291.3,38.4 M285.2,50.3c-0.1,0.3-0.1,0.7-0.1,1.1c0,1.8,1.3,2.4,4.5,2.4c3,0,7.1-0.7,9.6-1.6v8.3
			c-3.1,1.1-8,1.8-11.9,1.8c-9.2,0-13.6-2.5-13.6-10.8c0-8.2,3.8-20.9,18.4-20.9c9.3,0,12.1,4.2,12.1,8.6
			C304.2,44.9,299.3,49.8,285.2,50.3 M326.5,42.1c-0.9-0.2-1.8-0.3-2.8-0.3c-2.6,0-4.6,2.6-5.5,7.3l-2.4,12.3h-11.6l5.8-29.7h8.7
			l0.3,4c2.7-3.3,4.8-5,8-5c1.5,0,2.3,0.1,2.7,0.2L326.5,42.1 M362.7,31.6c-5.1,13.3-9.6,23-14.2,29.7c-6.6,9.8-12.4,12.1-18.3,12.1
			c-1.8,0-3.6-0.5-4.5-0.9l1.8-8.6h4c2,0,2.8-0.8,4.1-2.5c-2.2-8-3.3-19.2-3.2-29.7H344c-0.2,4.8-0.2,9.6,0.1,14.3
			c0.1,1.3,0.2,2.6,0.3,3.8h0.1c0.5-1.2,1.1-2.4,1.6-3.7c1.9-4.7,3.6-9.6,5-14.5L362.7,31.6 M407.2,61.3H395l2.9-14.9h-10.4
			l-2.9,14.9h-12.2l7.7-39.6h12.3l-2.8,14.2h10.3l2.8-14.2h12.2L407.2,61.3 M431.2,38.4c-2.7,0-4.2,2.2-4.8,4.8c5.3,0,6.9-1.7,6.9-3
			C433.3,39.2,432.4,38.4,431.2,38.4 M425.1,50.3c-0.1,0.3-0.1,0.7-0.1,1.1c0,1.8,1.3,2.4,4.5,2.4c3,0,7.2-0.7,9.6-1.6v8.3
			c-3.1,1.1-8,1.8-11.9,1.8c-9.2,0-13.6-2.5-13.6-10.8c0-8.2,3.8-20.9,18.4-20.9c9.3,0,12.1,4.2,12.1,8.6
			C444.2,44.9,439.2,49.8,425.1,50.3 M466.4,42.1c-0.9-0.2-1.8-0.3-2.8-0.3c-2.5,0-4.6,2.6-5.5,7.3l-2.4,12.3h-11.6l5.8-29.7h8.7
			l0.3,4c2.7-3.3,4.8-5,8-5c1.5,0,2.3,0.1,2.7,0.2L466.4,42.1 M485.4,39.7c-4.6,0-5.9,7.1-5.9,10.3c0,2.5,1.1,3.3,3.2,3.3
			c4.6,0,5.8-7.1,5.8-10.3C488.5,40.5,487.4,39.7,485.4,39.7 M481.1,62.4c-9,0-13.4-3.9-13.4-11.6c0-8.6,4.2-20.2,19.2-20.2
			c9,0,13.4,4,13.4,11.6C500.3,50.9,496.1,62.4,481.1,62.4 M152.6,51.9h-2.3l4.1-20.9h3.2c4.8,0,6.6,2.8,6.6,6.8
			C164.1,45.7,159.8,51.9,152.6,51.9 M163.4,31.8l7.7-7.4c-3-1.8-7.1-2.6-12.3-2.6H144l-7.7,39.6h15.4c17.9,0,25-12.5,25-25.5
			c0-3.4-0.7-6.1-2.1-8.2L163.4,31.8"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
}
